document.addEventListener('DOMContentLoaded', () => {
    const animateItems = document.querySelectorAll('.animate-item');

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const item = entry.target;
                const delay = item.getAttribute('data-delay') || '0s';
                
                item.style.animationDelay = delay;
                item.classList.add('is-visible');
                
                // アニメーション終了時の処理を修正
                item.addEventListener('animationend', () => {
                    // is-animated クラスは最終的なスタイルを持つため、
                    // is-visible を削除する前に is-animated を追加してスタイルが保持されるようにします。
                    item.classList.add('is-animated');
                    item.classList.remove('is-visible'); 
                    item.style.animationDelay = '';
                }, { once: true });
                
                observer.unobserve(item);
            }
        });
    }, {
        root: null,
        rootMargin: '0px',
        threshold: 0.1
    });

    animateItems.forEach(item => {
        observer.observe(item);
    });
});